// INFO: The io framework is beeing imported globally (TOOD: Replace io framework)
// import io from './plugins/io.js'
// import address from './components/address.js'
// import spamEmailProtection from './components/email-spam-protection.js'
import navmain from './components/nav-main.js'

export default {
    // io,
    // address,
    navmain,
    // spamEmailProtection
}
